// extracted by mini-css-extract-plugin
export default {"productDescription":"Waa-z","featuredDescription":"Xaa-z","description":"Yaa-z","more":"Zaa-z","descriptionSku":"_aa-z"};